<div>
  <div class="absolute inset-0">
    <img src="/assets/images/auth/bg-gradient.png" alt="image" class="h-full w-full object-cover" />
  </div>

  <div class="relative flex min-h-screen items-center justify-center bg-black bg-cover bg-center bg-no-repeat px-6 py-10 dark:bg-[#060818] sm:px-16">
    <div
      class="relative w-full max-w-[570px] rounded-md bg-[linear-gradient(45deg,#fff9f9_0%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_75%,_#fff9f9_100%)] p-2 dark:bg-[linear-gradient(52.22deg,#0E1726_0%,rgba(14,23,38,0)_18.66%,rgba(14,23,38,0)_51.04%,rgba(14,23,38,0)_80.07%,#0E1726_100%)]"
    >
      <div class="relative flex flex-col justify-center rounded-md bg-white/90 px-6 py-20 backdrop-blur-lg dark:bg-black/50 lg:min-h-[458px]">
        <div class="absolute end-6 top-6">
          <div class="dropdown">
            <div hlMenu>
              <button
                type="button"
                hlMenuButton
                class="flex items-center gap-2.5 rounded-lg border border-white-dark/30 bg-white px-2 py-1.5 text-white-dark hover:border-primary hover:text-primary dark:bg-black"
              >
                <div>
                  <img [src]="'/assets/images/flags/'+ store.locale.toUpperCase() + '.svg'" alt="image" class="h-5 w-5 rounded-full object-cover" />
                </div>
                <div class="text-base font-bold uppercase">{{ store.locale }}</div>
                <span class="shrink-0">
                  <icon-caret-down />
                </span>
              </button>
              <ul
                *hlMenuItems
                @toggleAnimation
                class="top-11 grid w-[280px] grid-cols-2 gap-2 !px-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:-right-14 sm:ltr:-right-2 rtl:-left-14 sm:rtl:-left-2"
              >
                <li *ngFor="let item of store.languageList;">
                  <button
                    *hlMenuItem="let menuItem"
                    type="button"
                    class="w-full hover:text-primary"
                    [ngClass]="{ 'bg-primary/10 text-primary': translate.currentLang === item.code }"
                    (click)="changeLanguage(item)"
                  >
                    <img class="h-5 w-5 rounded-full object-cover" [src]="'/assets/images/flags/'+ item.code.toUpperCase() + '.svg'" alt="" />
                    <span class="ltr:ml-3 rtl:mr-3">{{ item.name }}</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mx-auto w-full max-w-[440px]">
          <div class="mb-10">
            <h1 class="text-3xl font-extrabold uppercase !leading-snug text-primary md:text-4xl">{{'log_in_title' | translate}}</h1>
            <p class="text-base font-bold leading-normal text-white-dark">{{'log_in_description' | translate}}</p>
          </div>
          <form class="space-y-5 dark:text-white" [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
            <div>
              <label for="email">Email</label>
              <div class="relative text-white-dark">
                <input id="email" type="text" placeholder="Enter Email" class="form-input ps-10 placeholder:text-white-dark" formControlName="email" required />
                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                  <icon-user [fill]="true" />
                </span>
              </div>
            </div>
            <div>
              <label for="Password">{{'password' | translate}}</label>
              <div class="relative text-white-dark">
                <input id="Password" [type]="passwordVisible ? 'text' : 'password'" placeholder="Enter Password" class="form-input ps-10 placeholder:text-white-dark" formControlName="password" required />
                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                  <icon-lock-dots [fill]="true" />
                </span>
                <button type="button" class="absolute focus:outline-0 inset-y-0 right-0 flex items-start pr-3 pt-2" tabindex="-1" (click)="togglePasswordVisibility()">
                  <icon-eye-closed *ngIf="!passwordVisible; else hideIcon" class="dark:text-white" />
                  <ng-template #hideIcon>
                    <icon-eye-open class="dark:text-white" />
                  </ng-template>
                </button>
              </div>
            </div>
            <button *ngIf="!isLoading" type="submit" class="btn btn-primary !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]">{{'login_in' | translate}}</button>
            <button type="button" *ngIf="isLoading" class="btn btn-primary !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]">
              <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>Loading
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
